import React from 'react';
import TreeFilter from './TreeFilter';
import { useSelector } from 'react-redux';
import { IState } from '@/state/IState';
import { ItemCategory } from '@/types';

interface ItemCategoryFilterProps {
    value: number[];
    onChange: (value: number[]) => void;
    // onlyTopLevel?: boolean;
    itemCategories?: ItemCategory[];
    maxDepth?: number;
}

const ItemCategoryFilter: React.FC<ItemCategoryFilterProps> = ({ itemCategories, value, onChange, maxDepth }) => {
    const icState = useSelector((state: IState) => state.global.itemCategories);
    let ic = itemCategories ? itemCategories : icState;
    // if (onlyTopLevel) {
    //     ic = ic.map((ic) => ({ ...ic, subCategories: [] }));
    // }

    return (
        <div>
            <TreeFilter
                data={ic}
                value={(value || []).map((x) => +x)}
                idField="id"
                nameField="name"
                childrenField="subCategories"
                onChange={onChange}
                maxDepth={maxDepth}
            />
        </div>
    );
};

export default ItemCategoryFilter;